import React from 'react';
import { Loading } from '../Loading/Loading';
import { Overlay } from './FullPageLoading.styles';
import { LoadingSize, LoadingVariant } from '../Loading/Loading.styles';

interface FullPageLoadingProps {
  text?: string;
  size?: LoadingSize;
  variant?: LoadingVariant;
}

export const FullPageLoading: React.FC<FullPageLoadingProps> = ({
  text,
  size = 'large',
  variant = 'dark',
}) => {
  return (
    <Overlay>
      <Loading variant={variant} size={size} text={text} />
    </Overlay>
  );
};
